import { DateTime } from 'luxon';

// Two small utilities the other sync modules share: one reads the generation number off a
// PouchDB revision string, the other subtracts two timestamps. They sit here rather than in
// whichever subject module happened to define them first, because callers in several
// different subjects need them and none of those subjects owns them.
//
// They live outside DatabaseWrapper for the same reason every other sync helper does: that
// class imports pouchdb-browser, which references `self` and cannot be loaded under node, so
// anything that wants a unit test is extracted into a module of its own.

/** Parse the generation number from a CouchDB/PouchDB `_rev` ("N-hash" -> N). */
export function parseRevGeneration(rev: string | null | undefined): number {
  if (!rev) return 0;
  return parseInt(rev.split('-')[0], 10) || 0;
}

/**
 * Milliseconds elapsed since an ISO timestamp, clamped to 0 and treating a missing or
 * unparseable timestamp as 0 (#4010 B3 — used for the canary-report-to-flush delay of
 * `sync_stale_unflushed_outcome`; the same parse-guard-clamp shape as the other deciders,
 * extracted so the garbage-timestamp edge is unit-testable).
 */
export function elapsedSinceIsoMs(iso: string | undefined, nowMs: number): number {
  if (!iso) return 0;
  const thenMs = DateTime.fromISO(iso).toMillis();
  if (!Number.isFinite(thenMs)) return 0;
  return Math.max(0, nowMs - thenMs);
}
